import { useIntl } from 'react-intl'

import Box from 'app/components/base/Box'
import SelectField from 'app/components/fields/SelectField'
import { sortingProductsOptions } from 'app/features/Store/utils/options.constants'
import { transformIntlOptions } from 'app/utils/helpers/transforms.helper'

const ProductsSort: RFC = () => {
  const intl = useIntl()

  return (
    <Box>
      <SelectField
        label={intl.formatMessage({
          defaultMessage: 'Sort By'
        })}
        size="small"
        name="sorting"
        variant="button"
        optionSettings={{
          options: transformIntlOptions(
            sortingProductsOptions,
            intl.formatMessage
          ),
          optionLabel: 'name',
          optionValue: 'value'
        }}
        sx={{
          my: 1.2,
          fontSize: '15px',
          color: 'text.primary'
        }}
      />
    </Box>
  )
}

export default ProductsSort
